<template>
  <v-content>
    <v-container fluid>
      <Header :title="title" />
      <v-row class="mt-n3">
        <v-col cols="3">
            <v-autocomplete
              v-model="selectedGroupIds"
              :items="groups"
              item-value="group_id"
              item-text="group_name"
              :label="'Groups' | translate"
              outlined
              autocomplete="off"
              chips
              small-chips
              multiple
              required
              :no-data-text="$t('No data available')"
              @change="changedFilter"
            >
          </v-autocomplete>
        </v-col>
      </v-row>

      <v-row no-gutters>
        <v-col cols="12">
          <DataTable
            @csvmodal="csvmodal"
            @editing="editing"
            @deleting="deleting"
            @showView="showView"
            @changestatus="changestatus"
            @showDocuments="showDocuments"
            @settingsregistration="settingsregistration"
            :title="''"
            :itemkeyvalue="itemkeyvalue"
            :headers="headers"
            :items="users"
            :search="search"
          />
        </v-col>
        <Dialogbox
          @closing="closing"
          @deleteuser="deleteuser"
          :title="dialogboxtitle"
          :dialog="dialogstatus"
          :buttonTitle="dialogButtontitle"
          :deleteuser="true"
          v-if="dialogstatus"
        />

        <v-dialog v-model="settingsdialog" persistent max-width="500px">
          <v-card>
            <v-card-title>
              <span class="headline">{{ 'Settings'| translate }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-form id="formregister" ref="formregister">
                  <v-row>
                    <v-col cols="12" sm="12">
                      <v-select
                        v-model="allow_registration"
                        :items="allowregistrationvalues"
                        item-value="value"
                        item-text="name"
                        :label="'Allow registration' | translate"
                        autocomplete="off"
                        name="allowregistration"
                        :rules="allowregistrationRules"
                        outlined
                        required
                        :no-data-text="$t('No data available')"
                      >
                      <template #message="{ message }">
                        {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                      </template>                       
                      </v-select>
                    </v-col>
                  </v-row>
                </v-form>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="settingsdialog=false">{{ 'Close'| translate }}</v-btn>
              <v-btn color="blue darken-1" text @click="saveRegistrationSettings">{{ 'Save'| translate }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>


        <v-dialog v-model="dialog" persistent max-width="500px">
          <v-card>
            <v-card-title>
              <span class="headline">{{ 'Invite Users'| translate }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-form id="form" ref="form">
                  <v-row>
                    <v-col cols="12" sm="12">
                      <v-alert dense outlined v-if="message !==null && message.length >0" type="success">{{ message }}</v-alert>
                      <v-alert dense outlined v-if="errors !==null && errors.length > 0" type="error">{{ errors }}</v-alert>
                    </v-col>
                    <v-col cols="12" sm="12">
                      <v-file-input
                        id="csv"
                        name="csv"
                        outlined
                        chips
                        required
                        :label="'User csv file' | translate"
                        @change="onFileSelected"
                      ></v-file-input>
                    </v-col>
                  </v-row>
                </v-form>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="dialog=false">{{ 'Close'| translate }}</v-btn>
              <v-btn color="blue darken-1" text @click="uploadCsv">{{ 'Upload'| translate }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </v-container>
    <v-btn dark fab fixed bottom right large color="pink" class="mx-2" v-if="Object.keys(currentUser).length !=0 &&  currentUser.roles.includes(1)" @click="addUser">
      <v-icon>mdi-plus</v-icon>
    </v-btn>
  </v-content>
</template>

<script>
import { mapGetters } from "vuex"
import { mapState } from "vuex"
import store from "@/store"
import {
  FETCH_USERS,
  DELETE_USER,
  UPLOAD_USERS_CSV,
  UPDATE_USER_STATUS,
  FETCH_USER_DOCUMENTS,
  FETCH_USER_REGISTRATION_STATUS,
  SAVE_USER_REGISTRATION_STATUS,
  FETCH_ROLES,
  FETCH_GROUPS,
  RESET_STATE
} from "@/store/actions.type";
import { SET_LOADING, SET_ROUTER_ENTER, SET_SNACKBAR } from "@/store/mutations.type"
export default {
  name: "ExternalUsers",
  beforeRouteEnter(to, from, next) {
    store.dispatch(RESET_STATE),
    store.dispatch(FETCH_ROLES),
    store.dispatch(FETCH_GROUPS, ""),
    store.dispatch(FETCH_USERS, "?role=external-user").then(resp => {
      if (resp.success) {
        store.commit(SET_LOADING, false)
        store.commit(SET_ROUTER_ENTER, false)

      }
    });
    return next();
  },
  created(){
    if(this.currentUser.roles.includes(1) ==false && this.currentUser.roles.includes(3)== false){
      this.$router.push('/dashboard');
    }
  },
  data: function() {
    return {
      title: "External Users",
      search: "",
      dialogstatus: false,
      dialogButtontitle: null,
      dialogboxtitle: null,
      userdeleteid: null,
      settingsdialog: false,
      singleSelect: "",
      allow_registration: false,
      dialog: false,
      inviteusercsv: null,
      singleexpand: 'true',
      itemkeyvalue: 'email',
      showexpandstatus: 'true',
      message: null,
      role_names:[],
      selectedGroupIds: [],
    };
  },
  watch: {
    dialog(val) {
      if (!val) {
        this.$store.state.users.usererrors = null
        this.message = null
        this.inviteusercsv = null
        this.$refs.form.reset()
      }
    }
  },
  components: {
    DataTable: () => import("@/components/datatable/datatable"),
    Dialogbox: () => import("@/components/dialog/dialog"),
    Header: () => import("@/components/header/Header")
  },
  computed: {
    ...mapGetters(["users", "currentUser", "allowregistration", "roles", "groups"]),
    ...mapState({
      errors: state => state.users.usererrors
    }),
      headers(){ return [
        { text: this.$t("Name"), value: "name" },
        { text: this.$t("Last login"), value: "last_login" },
        { text: this.$t("Role"), value: "roles" },
        { text: this.$t("Status"), value: "status" },
        { text: this.$t("Actions"), value: "action", sortable: false },
      ]
      },

      allowregistrationvalues(){ return [
        { value: "0", name: this.$t("No") },
        { value: "1", name: this.$t("Yes") },
      ]},
      allowregistrationRules(){ return [v => !!v || "Registration status is required"]},
  },
  methods: {
    changedFilter(){
      store.dispatch(FETCH_USERS, "?group_ids="+this.selectedGroupIds+"&type=external");
    },
    async settingsregistration(){
      this.allow_registration = false
      await this.$store.dispatch(FETCH_USER_REGISTRATION_STATUS, 'user').then(async resp => {
        if (resp.success) {
          this.allow_registration = (this.allowregistration ==0 ? '0' :'1')
          await this.$store.commit(SET_LOADING, false)
          this.settingsdialog = true
        }
      })
    },
    addUser() {
      this.$router.push("/ext-users/add");
    },
    editing(id) {
      this.$router.push("/ext-users/edit/" + id)
    },
    showView(id) {
      this.$router.push("/ext-users/view/"+id)
    },
    async saveRegistrationSettings(){
      if (this.$refs.formregister.validate()) {
        var formData = new FormData(document.getElementById("formregister"))
        formData.set("allow_registration", this.allow_registration)
        this.$store.dispatch(SAVE_USER_REGISTRATION_STATUS,formData).then(resp =>{
          if (resp != undefined && resp.success) {
            this.$store.commit(SET_LOADING, false)
            this.$store.commit(SET_SNACKBAR, {status: true, message: 'Registration status changed successfully'})
            this.settingsdialog =false
          }   
          else{
            this.$store.commit(SET_LOADING, false)
          }       
        })
      }
    },    
    deleting(id) {
      this.dialogstatus = true
      this.dialogboxtitle = "Are you sure want to remove?"
      this.dialogButtontitle = "Remove"
      this.userdeleteid = id
    },
    async deleteuser() {
      await this.$store
        .dispatch(DELETE_USER, this.userdeleteid)
        .then(async resp => {
          if (resp !=undefined && resp.success) {
            this.userdeleteid = null;
            await store.dispatch(FETCH_USERS, "").then(resp => {
              if (resp.success) {
                store.commit(SET_LOADING, false);
                this.dialogstatus = false;
              }
            });
          }
          else{
            store.commit(SET_LOADING, false);
          }
        });
    },
    async showDocuments(id){
      await this.$store
        .dispatch(FETCH_USER_DOCUMENTS, '?item_id='+ id+'&status=active&inbox_filter=false').then( resp =>{
          if(resp.success){
            store.commit(SET_LOADING, false);
          }
        })
    },
    async changestatus(user){
      if(user.status == 'active'){
        user.status = 'disable'
        user._method = 'put'
        await this.$store.dispatch(UPDATE_USER_STATUS, user).then(resp =>{
          if (resp !=undefined && resp.success) {
            store.commit(SET_LOADING, false)
          }      
          else{
            store.commit(SET_LOADING, false)
          }    
        })
      }
      else {
        user.status = 'active'
        user._method = 'put'
        await this.$store.dispatch(UPDATE_USER_STATUS, user).then(resp =>{
          if (resp !=undefined && resp.success) {
            store.commit(SET_LOADING, false)
          }else{
            store.commit(SET_LOADING, false)
          }       
        })
      }
    },
    closing() {
      this.dialogstatus = false
    },
    mounted(){
      let company_meta  = JSON.parse(this.currentUser.company.company_meta)

      if(this.currentUser.roles.includes(1) && (company_meta.has_external_users == 'false' || company_meta.has_external_users == null) ){
        this.$router.push('/dashboard')
      }
    }, 
    csvmodal() {
      this.dialog = true
    },
    onFileSelected() {
      this.inviteusercsv = document.getElementById("csv").files[0]
    },
    uploadCsv() {
      if (this.inviteusercsv != null) {
        var formData = new FormData(document.getElementById("form"))
        formData.set("file", this.inviteusercsv)
        this.$store.dispatch(UPLOAD_USERS_CSV, formData).then(resp => {
          if (resp !=undefined && resp.success) {
            this.$store.state.users.usererrors = null
            this.$store.dispatch(FETCH_USERS, "")
            this.message = "Users successfully Invited"
            store.commit(SET_LOADING, false)
          }
          else{
            store.commit(SET_LOADING, false)
          }
        });
      } else {
        this.$store.state.users.usererrors = this.$t("Please upload a file") 
      }
    }
  }
};
</script>